/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Phone/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Phone({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/Topbar/Sms/Phone"
  
}) {
  let isMedia = useIsMedia()
let threadInboundNotificationValueData = fromData.useDataFormat({ viewPath,
context: 'thread',
path: 'inbound_notification',
format: fromFormat.phoneNumberUS,
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXs}
 data="thread.inbound_notification"
 format="/Data/format.js phoneNumberUS"
 text={threadInboundNotificationValueData}
 size={isMedia.mobile ? "tiny" : "medium"}
/>
{children}
</React.Fragment>)
}